var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "#5990E4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20554 0.846455L4.86096 0.347724C5.40731 0.183387 5.99483 0.22326 6.51392 0.459905C7.03301 0.69655 7.44823 1.1138 7.68212 1.63384L8.84271 4.21289C9.04415 4.66032 9.10029 5.15955 9.00327 5.64049C8.90624 6.12143 8.66091 6.55993 8.30173 6.89443L6.5352 8.53922C6.29846 8.76382 6.47794 9.63916 7.34283 11.1371C8.20857 12.6358 8.87775 13.2285 9.18628 13.1363L11.5006 12.4292C11.9697 12.2858 12.472 12.2927 12.937 12.4489C13.402 12.6051 13.8064 12.9028 14.0936 13.3002L15.743 15.5847C16.0762 16.0459 16.2305 16.6124 16.1772 17.1788C16.1239 17.7452 15.8667 18.273 15.4533 18.6641L14.1782 19.8708C13.7666 20.2604 13.2589 20.5338 12.707 20.6633C12.1551 20.7928 11.5787 20.7736 11.0366 20.6078C8.36497 19.7906 5.8908 17.3652 3.58072 13.366C1.26551 9.36076 0.39122 5.98236 1.00057 3.22226C1.12348 2.6661 1.39259 2.15276 1.78017 1.73514C2.16775 1.31753 2.65978 1.01076 3.20554 0.846455Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ef349b065a98f5caffd238cd507498da.svg";
export { ForwardRef as ReactComponent };